var map = {
	"./Canvas.vue": 241,
	"./DocumentIframe.js": 7229,
	"./Gallery.vue": 8484,
	"./ModeAndViewportToolbar.vue": 2402,
	"./ToolbarTop.vue": 1847,
	"./VersionActions.vue": 8076,
	"./tooltip.js": 2685
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8513;